import selectLocalExercise from './selectLocalExercise';
const selectCurrentAnswers = (state, exerciseId) => {
  const localExercise = selectLocalExercise(state, exerciseId);
  if (localExercise === undefined) {
    return undefined;
  }
  return localExercise.currentAnswers;
};
export default selectCurrentAnswers;